import { Component, OnInit, inject, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { SessionBootstrapService } from '../../services/session-bootstrap.service';
import { HeaderComponent } from '../header/header.component';
import { SidebarComponent } from '../sidebar/sidebar.component';

/**
 * Main layout component for authenticated users
 * Contains header, sidebar, and main content area
 */
@Component({
  selector: 'app-main-layout',
  standalone: true,
  imports: [
    RouterOutlet,
    HeaderComponent,
    SidebarComponent
  ],
  templateUrl: './main-layout.component.html',
  styleUrl: './main-layout.component.scss'
})
export class MainLayoutComponent implements OnInit {
  private sessionBootstrapService = inject(SessionBootstrapService);

  // Track initialization state - starts false, becomes true when everything is ready
  ready = signal(false);

  async ngOnInit() {
    try {
      await this.sessionBootstrapService.initializeSession();
      this.ready.set(true);
      await new Promise(resolve => requestAnimationFrame(() => resolve(null)));
      this.hideLoadingScreen();
    } catch (error) {
      console.error('Error during main layout initialization:', error);
      // Session bootstrap service handles token refresh failures
      // If we reach here, just hide loading screen
      this.hideLoadingScreen();
    }
  }

  /**
   * Hide and remove the loading screen element
   */
  private hideLoadingScreen(): void {
    const loadingElement = document.getElementById('initial-loading');
    if (loadingElement) {
      loadingElement.classList.add('loaded');
      setTimeout(() => loadingElement.remove(), 400);
    }
  }
}
